<nb-stepper orientation="horizontal" (stepChange)="onStepChange($event)" disableStepNavigation>
    <nb-step *ngFor="let contentElement of contentElements" 
        [label]="getEnumValue(contentElement)">
        <div class="step-content-wrapper">
            <div class="preview-content" [attr.id]="cell.cellId">
                <p>{{contentElement.name}}</p>
            <pre [innerHTML]="contentElement | json"></pre>
            </div>
            
            <div class="button-wrapper">
                <button nbButton [disabled]="firstStep" nbStepperPrevious size="small" class="btn-right">prev</button>
                <button nbButton nbStepperNext size="small">next</button>
                <button nbButton size="small" status="primary" (click)="onSubmitContent()" [disabled]="!lastStep">Done<nb-icon icon="checkmark-outline" pack="eva" status="success"></nb-icon></button>
            </div>

        </div>

    </nb-step>
</nb-stepper>
